<template>
  <div>
    <table style="margin-left: calc(75%); border-collapse: collapse; border: none; width: 25%;">
      <tbody>
        <tr>
          <td colspan="2"
            style="width: 125.05pt;border: 1pt solid black;padding: 0cm;height: 14.1pt;vertical-align: top;">
            <p
              style='margin-top:2.2pt;margin-right:0cm;margin-bottom:.0001pt;margin-left:6.3pt;font-size:15px;font-family:"Arial",sans-serif;'>
              <span style="font-size:11px;">REGISTRO DOCUMENTOS</span></p>
          </td>
        </tr>
        <tr>
          <td
            style="width: 68.4pt;border-right: 1pt solid black;border-bottom: 1pt solid black;border-left: 1pt solid black;border-image: initial;border-top: none;padding: 0cm;height: 9.05pt;vertical-align: top;">
            <p
              style='margin-top:0cm;margin-right:0cm;margin-bottom:.0001pt;margin-left:6.3pt;font-size:15px;font-family:"Arial",sans-serif;line-height:8.1pt;'>
              <span style='font-size:11px;font-family:"Georgia",serif;'>&nbsp;</span><span
                style="font-size:11px;">ENTRADA</span></p>
          </td>
          <td
            style="width: 56.65pt;border-top: none;border-left: none;border-bottom: 1pt solid black;border-right: 1pt solid black;padding: 0cm;height: 9.05pt;vertical-align: top;">
            <p
              style='margin-top:0cm;margin-right:0cm;margin-bottom:.0001pt;margin-left:6.3pt;font-size:15px;font-family:"Arial",sans-serif;line-height:8.1pt;'>
              <span style='font-size:11px;font-family:"Georgia",serif;'>&nbsp;</span><span
                style="font-size:11px;">SALIDA</span></p>
          </td>
        </tr>
        <tr>
          <td colspan="2"
            style="width: 125.05pt;border-right: 1pt solid black;border-bottom: 1pt solid black;border-left: 1pt solid black;border-image: initial;border-top: none;padding: 0cm;height: 36.55pt;vertical-align: top;">
            <p
              style='margin-top:.15pt;margin-right:0cm;margin-bottom:.0001pt;margin-left:0cm;font-size:15px;font-family:"Arial",sans-serif;'>
              <span style='font-size:10px;font-family:"Times New Roman",serif;'>&nbsp;</span></p>
            <p
              style='margin-top:0cm;margin-right:0cm;margin-bottom:.0001pt;margin-left:6.3pt;font-size:15px;font-family:"Arial",sans-serif;line-height:9.15pt;'>
              <span style="font-size:11px;">N&ordm; REGISTRO: 916</span></p>
            <p
              style='margin-top:.2pt;margin-right:0cm;margin-bottom:.0001pt;margin-left:6.3pt;font-size:15px;font-family:"Arial",sans-serif;line-height:9.1pt;'>
              <span style="font-size:11px;">FECHA: 12/07/2019&nbsp;</span><span
                style='font-size:11px;font-family:"Georgia",serif;'>&nbsp;</span><span style="font-size:11px;">ANEJOS
                ARCHIVO: SOB</span></p>
          </td>
        </tr>
      </tbody>
    </table>
    <p style="text-align:center;">
      <img
        src="data:image/jpeg;base64,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"
        height="100px" width="100px" /></p>
    <p
      style="margin: 4.5pt 322.5pt 0.0001pt 7.05pt; font-size: 13px; font-family: Arial, sans-serif; text-align: left;">
      Expediente: <br>
      {{datos.auditoria.expediente.codigo}} <br>
      Fecha:  {{formatDate(datos.fecha_proposicion)}}</p>
      <br>
    <p style='margin:0cm;margin-bottom:.0001pt;font-size:13px;font-family:"Arial",sans-serif;margin-top:.25pt;'><span
        style="font-size:7px;">&nbsp;</span></p>
    <p
      style="margin: 4.55pt 0cm 0.0001pt 254.85pt; font-size: 13px; font-family: Arial, sans-serif; line-height: 11.45pt; text-align: right;">
      <u>{{ clienteNombreCompleto }}</u><br></p>
    <p
      style="margin: 0cm 8.05pt 0.0001pt 254.85pt; font-size: 13px; font-family: Arial, sans-serif; text-align: right;">
      
                C/ {{ datos.cliente && datos.cliente.direccion }} - C.P. {{ datos.cliente.cp }} - {{ datos.cliente.municipio.nombre }} ({{ datos.cliente.provincia.nombre }})</p>
    <p
      style="margin: 0.05pt 0cm 0.0001pt 254.85pt; font-size: 13px; font-family: Arial, sans-serif; text-align: right;">
      Att: {{ clienteNombreCompleto }}</p>
    <p style='margin:0cm;margin-bottom:.0001pt;font-size:13px;font-family:"Arial",sans-serif;'><span
        style="font-size:15px;">&nbsp;</span></p>
    <p style='margin:0cm;margin-bottom:.0001pt;font-size:13px;font-family:"Arial",sans-serif;'><span
        style="font-size:15px;">&nbsp;</span></p>
    <p
      style='margin:0cm;margin-bottom:.0001pt;font-size:13px;font-family:"Arial",sans-serif;margin-top:8.8pt;margin-right:0cm;margin-left:7.05pt;'>
      ASUNTO: &nbsp; &nbsp; &nbsp; &nbsp;<u>CONCESI&Oacute;N DE LA CERTIFICACI&Oacute;N-EXPEDIENTE {{datos.auditoria.expediente.codigo}}</u></p>
    <p style='margin:0cm;margin-bottom:.0001pt;font-size:13px;font-family:"Arial",sans-serif;margin-top:.5pt;'><span
        style="font-size:9px;">&nbsp;</span></p>
    <p
      style='margin:0cm;margin-bottom:.0001pt;font-size:13px;font-family:"Arial",sans-serif;margin-top:4.5pt;margin-right:0cm;margin-left:7.05pt;text-align:justify;'>
      Muy Sres. M&iacute;os:</p>
    <p style='margin:0cm;margin-bottom:.0001pt;font-size:13px;font-family:"Arial",sans-serif;margin-top:.4pt;'><span
        style="font-size:13px;">&nbsp;</span></p>
    <p
      style='margin:0cm;margin-bottom:.0001pt;font-size:13px;font-family:"Arial",sans-serif;margin-top:0cm;margin-right:7.3pt;margin-left:7.05pt;text-align:justify;'>
      El Director T&eacute;cnico de Certificaci&oacute;n de CERTICAR, una vez analizado el correspondiente Informe de la
      Auditoria de Certificaci&oacute;n de producto {{datos.auditoria.expediente.codigo}}, tras la valoraci&oacute;n del Informe de acciones
      correctivas&nbsp;y/o&nbsp;preventivas&nbsp;propuestas,&nbsp;de&nbsp;los&nbsp;resultados&nbsp;anal&iacute;ticos&nbsp;obtenidos&nbsp;en&nbsp;las&nbsp;muestras&nbsp;tomadas,&nbsp;y
      del&nbsp;resto&nbsp;de&nbsp;la&nbsp;documentaci&oacute;n&nbsp;que&nbsp;soporta&nbsp;el&nbsp;expediente,&nbsp;y&nbsp;a&nbsp;la&nbsp;vista&nbsp;de&nbsp;los&nbsp;resultados&nbsp;obtenidos,&nbsp;acord&oacute;:
    </p>
    <p style='margin:0cm;margin-bottom:.0001pt;font-size:13px;font-family:"Arial",sans-serif;margin-top:.3pt;'><span
        style="font-size:15px;">&nbsp;</span></p>
    <p
      style='margin:0cm;margin-bottom:.0001pt;font-size:15px;font-family:"Arial",sans-serif;margin-top:0cm;margin-right:7.1pt;margin-left:7.05pt;text-align:justify;line-height:98%;'>
      <span style="font-size:12px;line-height:98%;">Conceder la certificaci&oacute;n conforme al Real Decreto 4/2014,
        por el que se aprueba la norma de calidad para la&nbsp;carne,
        el&nbsp;jam&oacute;n,&nbsp;la&nbsp;paleta&nbsp;y&nbsp;la&nbsp;ca&ntilde;a&nbsp;de&nbsp;lomo&nbsp;ib&eacute;rico,&nbsp;a&nbsp;la&nbsp;empresa&nbsp;{{ clienteNombreCompleto }},&nbsp;con&nbsp;n&nbsp;&ordm;&nbsp;de
        expediente {{datos.auditoria.expediente.codigo}}. El alcance de certificaci&oacute;n concedido se especifica en el Anexo T&eacute;cnico
        del Certificado de Conformidad de&nbsp;Producto.</span></p>
    <p style='margin:0cm;margin-bottom:.0001pt;font-size:13px;font-family:"Arial",sans-serif;margin-top:.45pt;'><span
        style="font-size:15px;">&nbsp;</span></p>
    <p
      style='margin:0cm;margin-bottom:.0001pt;font-size:13px;font-family:"Arial",sans-serif;margin-left:7.05pt;text-align:justify;'>
      Adjunto les remitimos los documentos vigentes correspondientes a su proceso de certificaci&oacute;n.</p>
    <p style='margin:0cm;margin-bottom:.0001pt;font-size:13px;font-family:"Arial",sans-serif;margin-top:.35pt;'><span
        style="font-size:13px;">&nbsp;</span></p>
    <p
      style='margin:0cm;margin-bottom:.0001pt;font-size:13px;font-family:"Arial",sans-serif;margin-top:.05pt;margin-right:7.15pt;margin-left:7.05pt;text-align:justify;'>
      Es una gran satisfacci&oacute;n para todos nosotros informarle del resultado positivo de su proceso de
      certificaci&oacute;n, como reconocimiento de la competencia t&eacute;cnica de su empresa para la
      realizaci&oacute;n de las actividades descritas en su anexo t&eacute;cnico.</p>
    <p style='margin:0cm;margin-bottom:.0001pt;font-size:13px;font-family:"Arial",sans-serif;margin-top:.25pt;'><span
        style="font-size:13px;">&nbsp;</span></p>
    <p
      style='margin:0cm;margin-bottom:.0001pt;font-size:13px;font-family:"Arial",sans-serif;margin-top:0cm;margin-right:7.25pt;margin-left:7.05pt;text-align:justify;'>
      El Director T&eacute;cnico de Certificaci&oacute;n de CERTICAR, felicita a la Empresa por el resultado del proceso
      de certificaci&oacute;n.</p>
    <p style='margin:0cm;margin-bottom:.0001pt;font-size:13px;font-family:"Arial",sans-serif;margin-top:.05pt;'><span
        style="font-size:15px;">&nbsp;</span></p>
    <p><span style='font-size:15px;font-family:"Arial",sans-serif;'><br>&nbsp;</span></p>
    <p
      style='margin:0cm;margin-bottom:.0001pt;font-size:13px;font-family:"Arial",sans-serif;margin-top:4.55pt;margin-right:0cm;margin-left:7.05pt;'>
      Sin otro particular, aprovecho la ocasi&oacute;n para saludarles.</p>
    <p><span style='font-size:5px;line-height:113%;font-family:"Trebuchet MS",sans-serif;'><br>&nbsp;</span></p>
    <p
      style='margin:0cm;margin-bottom:.0001pt;font-size:15px;font-family:"Arial",sans-serif;margin-top:.95pt;margin-right:7.2pt;margin-left:355.85pt;text-align:right;text-indent:-10.45pt;line-height:98%;'>
      <span style="font-size:12px;line-height:98%;">Fdo. &nbsp; &nbsp; &nbsp; &nbsp;Cristina Ortiz Barber&aacute;n
        <br>CERTICAR- Directora General</span></p>
    <p
      style='margin:0cm;margin-bottom:.0001pt;font-size:15px;font-family:"Arial",sans-serif;margin-top:.95pt;margin-right:7.2pt;margin-left:355.85pt;text-align:right;text-indent:-10.45pt;line-height:98%;'>
      <br></p>
    <p
      style='margin:0cm;margin-bottom:.0001pt;font-size:15px;font-family:"Arial",sans-serif;margin-top:.95pt;margin-right:7.2pt;margin-left:355.85pt;text-align:right;text-indent:-10.45pt;line-height:98%;'>
      <br></p>
    <p
      style='margin:0cm;margin-bottom:.0001pt;font-size:15px;font-family:"Arial",sans-serif;margin-top:.95pt;margin-right:7.2pt;margin-left:355.85pt;text-align:right;text-indent:-10.45pt;line-height:98%;'>
      <br></p>
    <p style='margin:0cm;margin-bottom:.0001pt;font-size:13px;font-family:"Arial",sans-serif;margin-top:.05pt;'><span
        style="font-size:13px;">&nbsp;</span></p>
        <hr>
    <p
      style='margin:0cm;margin-bottom:.0001pt;font-size:15px;font-family:"Arial",sans-serif;margin-left:7.05pt;line-height:8.2pt;'>
      <u><span style="font-size:11px;">N</span></u><u><span style="font-size:11px;">OTA</span></u><span
        style="font-size:11px;">: &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</span><em><span
          style="font-size:11px;">Le recordamos que la concesi&oacute;n de la certificaci&oacute;n de producto por
          CERTICAR les autoriza a la utilizaci&oacute;n de la</span></em></p>
    <p
      style='margin:0cm;margin-bottom:.0001pt;font-size:15px;font-family:"Arial",sans-serif;margin-top:.2pt;margin-right:0cm;margin-left:77.6pt;line-height:92%;'>
      <em><span style="font-size:11px;line-height:92%;">marca de certificaci&oacute;n (logotipo) de CERTICAR en las
          condiciones establecidas en los documentos: Procedimiento General de Certificaci&oacute;n de Productos
          Agroalimentarios y Procedimiento General de Uso de la Marca de CERTICAR.</span></em></p>
  </div>
</template>

<script>
  import MODELS from "~/models/araporcei/solicitudes"

  export default {
    props: {
      datos: {
        type: Object,
        default: () => {}
      }
    },
    data: function () {
      return {
        tipoAlimentacion: MODELS.ALIMENTACION_TIPO,
        tipoProducto: MODELS.PRODUCTO_TIPO,
        tipoRacial: MODELS.RACIAL_TIPO,
        tipoEstado: MODELS.ESTADOS_TIPO,
        tipoPresentacion: MODELS.PRESENTACION_TIPO,
        tipoCertificacion: MODELS.CERTIFICACION_TIPO,
      }
    },
    computed: {
      isOperadorResposable() {
        return this.datos.solicitud && this.datos.solicitud.params.alcance_proceso.tipo_operador.includes('responsable')
      },
      clienteNombreCompleto() {
        let nombre = ''
        const cliente = this.datos.cliente
        if (cliente) {
          if (cliente.nombre) nombre += cliente.nombre
          if (cliente.primer_apellido) nombre += ' ' + cliente.primer_apellido
          if (cliente.segundo_apellido) nombre += ' ' + cliente.segundo_apellido
        }
        return nombre
      },
      sites() {
        const planificacionesSites = this.datos.auditoria.planificaciones.map(e => e.site.uuid)

        const sites = this.datos.auditoria.sites.filter(e => e.certificado)

        const parentSites = sites.filter(e => planificacionesSites.includes(e.uuid))
        const parentSitesUuids = parentSites.map(e => e.uuid)

        const childrenSites = sites.filter(e => parentSitesUuids.includes(e.parent_uuid))

        return {
          instalaciones: this.getSiteData(parentSites),
          actividades: this.getSiteData(childrenSites)
        }
      },
      auditoriaSites() {
        return this.datos.auditoria.sites;
      },
      instalaciones() {
        const instalacionesNombre = this.sites.instalaciones.map(e => e.nombre)
        return this.datos.cliente.instalaciones.filter(element => {
          return instalacionesNombre.some(e => e.includes(element.rgseaa))
        })
      },
      actividades() {
        return this.sites.actividades
      },
      fechaDecision() {
        return this.datos.fecha_decision
      },
      productos() {
        const productos = []
        const alcance_producto = this.datos.solicitud.params.alcance_producto
        if (alcance_producto) {
          for (let i = 0; i < alcance_producto.length; i++) {
            const element = alcance_producto[i]
            const tipo_producto = this.tipoProducto[element.producto]
            if (!productos.includes(tipo_producto)) productos.push(tipo_producto)
          }
        }
        if (productos.length) {
          const start = productos.slice(0, productos.length - 1)
          const end = productos[productos.length - 1]
          return start.join(', ') + ' y ' + end
        } else return ''
      }
    },
    methods: {
      formatDate(date) {
        return date ? this.$moment(date).format('DD/MM/YYYY') : ''
      },
      formatDateLong(date) {
        return date ? this.$moment(date).format('LL') : ''
      },
      getSiteData(sites) {
        const data = []
        if (sites) {
          for (let i = 0; i < sites.length; i++) {
            const element = sites[i]
            let obj = {}
            obj.uuid = element.uuid
            obj.nombre = element.nombre
            obj.tipo = element.tipo
            for (let k = 0; k < element.site_data.length; k++) {
              const item = element.site_data[k]
              obj[item.keyname] = item.value
            }
            data.push(obj)
          }
        }
        return data
      },
      getSiteDataAggroupedBy(siteData, key) {
        return this.getataAggroupedBy(this.getSiteData(siteData), key);
      },
      getataAggroupedBy(data, key) {
        var agroupedData = []
        data.forEach(site => {
          if (site[key] === undefined) {
            return;
          }

          var elementExists = agroupedData.find(x => x.key == site[key])

          if (elementExists == null) {
            agroupedData.push({
              key: site[key],
              values: []
            });
          }

          agroupedData.find(x => x.key == site[key]).values.push(site);
        });

        return agroupedData;
      },
      // init () {
      //   if (!this.datos.fecha_decision) {
      //     this.$router.replace({ name: 'dictamenes' })
      //     const alert = {
      //       text: 'El dictamen no tiene fecha de decisión.',
      //       color: 'error'
      //     }
      //     this.$store.commit("notification/show", alert)
      //   }
      // }
    },
    // created () {
    //   this.init()
    // }
  }
</script>